//—— 故事頁那幾塊命書面板的「先發請求」——
//
//  ⚠️ 塊數會變：單身線 4 塊、尚未交往／已交往線 3 塊
//  （見 engines/feihong-teaser 的 PANELS_BY_LINE）。這支不管那件事 ——
//  它只負責「先發、單發、交棒」。
//
//  為什麼要一個模組層的暫存，而不是跟 intake 一樣用 location state 傳：
//  那幾段是 AI 生的，要幾秒。而送出的時機（開場按下「開始解命」）
//  比用到的時機（捲到第一塊面板）早很多 —— 中間隔著：
//    feihong-5（她批命 9.0 秒，不能跳過）
//    ＋ 使用者從頁首捲到整頁的 15~16%（量到 4036~4118px，約 10-20 秒）
//  合計 18~28 秒的掩護，而那支影片演的就是「她正在算」。
//
//  ⚠️ 發的時機跟白夜不一樣：白夜是**問診填完**就發，這裡是**按下開始解命**。
//  差別在那顆按鈕是一個明確的意願訊號 —— 在第一支影片（feihong-4，8.6 秒）
//  中途關掉頁面的人不會被算一次成本，而這支生成是付費前就要燒的。
//
//  location state 只能帶「已經有的值」，帶不了「還在路上的請求」。
//  硬要等請求回來再換頁的話，就等於把那幾秒變成一段卡住的黑畫面 ——
//  而我們本來有十幾秒的劇情可以拿來掩護它。
//
//  所以這裡存的是 Promise 不是結果：
//    故事頁的開場元件在「開始解命」被按下時呼叫 startTeaser()，不 await
//    生成回來之後才 setPanels（見 feihong-story-page 的 beginTeaser）
//  面板先被捲到就什麼都不掛，請求先回來就立刻有值。
//
//  —— 為什麼模組層的可變狀態在這裡是對的 ——
//  它跟著這一次瀏覽的生命週期走：重新整理就沒了。
//  但 intake 本來也是用 location state 傳的、重整一樣會沒，
//  故事頁遇到沒有 intake 就會把人導回劇情頁重填。兩者消失的時機一致，
//  不會出現「有問診資料但沒有命書」或反過來的狀態。
//
//  單發（single flight）：同一份問診資料只會真的打一次。
//  這不只是省錢 —— React 嚴格模式下 effect 會跑兩遍，
//  不擋的話每個使用者都會燒掉兩次 API 呼叫，而且兩份結果還不一樣
//  （temperature 0.9），後到的那份會蓋掉先到的。
//
//  換一份問診資料（使用者按返回改了答案再走一次）就重打 ——
//  所以比對的是問診內容本身，不是單純的「打過了沒」。

import generalService from "../../../service/general-service";

let pending = null;
let pendingKey = "";

//什麼算「同一份問診資料」。
//  只取會影響生成結果的欄位：兩個人的排盤要生辰與性別，
//  走哪一條故事線要 intent 與 status，寫文案要他填的煩惱。
//  信箱與姓名不算 —— 改了信箱不該重生一次（而且生成根本用不到）。
//
//  ⚠️ 這張清單原本是從白夜整份抄過來的，**沒改**（2026-10-22 修）：
//  那邊取的 relation／orientation／relationship／career 在緋紅的問診裡
//  根本不存在（永遠 undefined），而真正會變的那六個欄位
//  （intent、status、對方的性別與生辰）一個都沒在裡面。
//
//  後果不是少快取，是**拿到別人的盤**：使用者按返回改掉對方的生辰再走一次，
//  keyOf 算出來是同一把鑰匙 → 單發機制直接回舊的 Promise →
//  面板寫的是前一個對象的合盤，而且畫面上不會有任何異狀。
//
//  問診實際收的欄位見 match-feihong-page 的 SCENES（field:）——
//  加題目時這張清單要跟著加。
const keyOf = (intake) =>
  JSON.stringify([
    intake?.intent,
    intake?.status,
    intake?.gender,
    intake?.birthDate,
    intake?.birthTime,
    intake?.birthPlace?.label,
    intake?.partnerGender,
    intake?.partnerBirthDate,
    intake?.partnerBirthTime,
    intake?.partnerBirthPlace?.label,
    intake?.concern,
  ]);

//故事頁一掛載就呼叫，不要 await。
//  回傳的 Promise 永遠 resolve（失敗時 resolve 成 null）——
//  沒有人 await 它的時候，一個 reject 會變成 unhandled rejection。
export const startTeaser = (intake) => {
  const key = keyOf(intake);
  if (pending && pendingKey === key) return pending;

  pendingKey = key;
  pending = generalService
    .feihongTeaser(intake)
    .then(({ data }) => (data?.status ? data.data : null))
    .catch((e) => {
      console.warn("[緋紅] 命書生成失敗", e?.message);
      return null;
    });
  return pending;
};

//故事頁掛載時呼叫。沒有先發過就回 null（例如直接貼網址進故事頁）。
export const takeTeaser = () => pending;
